(() => {
  const urls = window.PUTZKOPF_ASSETS || {};
  const map = value => {
    if (typeof value === 'string') return urls[value] || value;
    if (Array.isArray(value)) return value.map(map);
    if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key, item]) => [urls[key] || key, map(item)]));
    return value;
  };
  window.PRODUKTE = map(window.PRODUKTE || []);
  window.BILD_ALT = map(window.BILD_ALT || {});
  const variants = (window.PUTZKOPF_COMMERCE || {}).variants || {};
  window.PRODUKTE.forEach(product => product.varianten.forEach(variant => {
    const live = variants[variant.ean];
    variant.shopifyId = live ? live.id : null;
    variant.available = !!(live && live.available);
    if (live) variant.preis = live.price / 100;
  }));
})();
